<template>
  <div>
    <div class="content" id="top">
      <div class="title-text">
        <p class="title">Referrals</p>
      </div>
      <div v-if="$apolloData.loading" class="content-body">
      Loading...
      </div>
      <div v-else class="content-body">
        <div class="coupon" v-if="!discount_code">
          <div class="description">
            <div class="title">Earn by sharing</div>
            <div class="text">
              <p>
                Sign up and get
                <span class="bold">20% commission</span>
                on your referred subscriptions
                <span class="bold">for life</span>.
              </p>
              <p>
                To make things even sweeter,
                <span class="bold">your invitees get an extra month free</span>.
              </p>
              <p>
                To get started,
                create your personalized link and add your PayPal email address.
              </p>
            </div>
          </div>
          <div class="separator"></div>
          <div class="coupon-code">
            <div class="title">Create your link</div>
            <div class="create-code" :class="{ 'is-invalid': couponExists }">
              <span>https://artisthub.io/r/</span>
              <input
                type="text"
                placeholder="CODEHERE"
                v-model="coupon"
              />
            </div>
            <div class="lets-go">
              <button
                class="button-primary big"
                :disabled="codeInvalid || addingCoupon"
                @click="createCoupon"
              >
                {{ addingCoupon ? 'Creating...' : 'Let’s go! 🤑' }}
              </button>
            </div>
          </div>
        </div>
        <div class="coupon" v-else>
          <div class="description">
            <div class="title">Earn by sharing</div>
            <div class="text">
              <p>
                Get
                <span class="bold">20% commission</span>
                on your referred subscriptions
                <span class="bold">for life</span>.
              </p>
              <p>
                To make things even sweeter,
                <span class="bold">your invitees get an extra month free</span>.
              </p>
              <p>
                Payouts for a month happen three weeks after the month.
                For example, August referrals get paid September 21st. $10 min payout.
              </p>
            </div>
          </div>
          <div class="separator"></div>
          <div class="coupon-code">
            <div class="title">Your link</div>
            <div class="your-link">
              <div class="code-container">
                <div class="code-text">
                  https://artisthub.io/r/<span>{{ discount_code.coupon }}</span>
                </div>
              </div>
              <div class="copy" @click="copyLink">
                <CopyIcon />
              </div>
            </div>
          </div>
        </div>
        <div class="results" v-if="discount_code && referralsData">
          <div class="title">Affiliate Program</div>
          <div class="summary">
            <div class="card">
              <span class="total">{{ referralsData.count_pending }}</span>
              <span class="label">Pending Users</span>
            </div>
            <div class="card">
              <span class="total">{{ referralsData.count_active }}</span>
              <span class="label">Active Users</span>
            </div>
            <!--
              <div class="card">
              <span class="total">${{ referralsData.payout }}</span>
              <span class="label">Pending Payout</span>
            </div>
            -->
            <div class="card">
              <span class="total">{{ referralsData.payout_date }}</span>
              <span class="label">Next Payout</span>
            </div>
          </div>
          <div class="title" v-if="affiliatePayouts.length">Payouts</div>
          <table v-if="affiliatePayouts.length">
            <thead>
              <tr>
                <th align="left">Payment Date</th>
                <th align="left">Active Users</th>
                <th align="left">Total Sales</th>
                <th align="left">Payout</th>
              </tr>
            </thead>
              <tbody>
                <tr v-for="(payout, i) in affiliatePayouts" :key="i" class="row">
                  <td>{{ payout.date }}</td>
                  <td>{{ payout.active_users }}</td>
                  <td>{{ payout.sales }}</td>
                  <td>{{ payout.payout }}</td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
      <SnackBar />
    </div>
  </div>
</template>

<script>
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import SnackBar from "@/components/Custom/SnackBar";
import CopyIcon from "../../../../public/img/icons/copy3.svg";
import {
  Q_CHECK_DISCOUNT_COUPON,
  Q_USER_COUPON,
  M_CREATE_COUPON,
  Q_REFERRALS_DATA,
  Q_AFFILIATE_PAYOUTS
} from "@/graphql";

export default {
  name: "Referrals",
  components: {
    SnackBar,
    CopyIcon
  },
  data() {
    return {
      discount_code: null,
      coupon: null,
      couponExists: false,
      addingCoupon: false,
      affiliatePayouts: [],
      referralsData: null
    };
  },
  apollo: {
    discount_code: {
      query: Q_USER_COUPON,
      result({ data }) {
        this.discount_code = data.discount_coupons[0];
      },
      variables() {
        return {
          user_id: this.user.id
        };
      },
      update: (data) => data,
    },
    referralsData: {
      query: Q_REFERRALS_DATA,
      client: "localClient",
      result({ data }) {
        this.referralsData = data.get_referrals_data;
      },
      variables() {
        return {};
      },
      update: (data) => data,
      skip() {
        return !this.discount_code;
      },
    },
    affiliatePayouts: {
      query: Q_AFFILIATE_PAYOUTS,
      result({ data }) {
        this.affiliatePayouts = data.affiliate_payouts;
      },
      variables() {
        return {};
      },
      update: (data) => data,
      skip() {
        return !this.discount_code;
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    codeInvalid() {
      return this.couponExists || !this.coupon;
    }
  },
  methods: {
    async createCoupon() {
      if (!this.coupon) return;

      try {
        this.addingCoupon = true;
        await this.$apollo.mutate({
          mutation: M_CREATE_COUPON,
          variables: {
            coupon: this.coupon.toUpperCase()
          }
        });

        this.coupon = null;
        await this.$apollo.queries.discount_code.refetch();

        this.addingCoupon = false;

        this.$store.dispatch("snack", {
          text: "Coupon created successfully"
        });
      } catch (e) {
        console.log(e);
        this.addingCoupon = false;
        this.$store.dispatch("snack", {
          text: "Error creating coupon",
          color: "error",
        });
      }
    },
    copyLink() {
      const vm = this;
      this.$copyText(`https://artisthub.io/r/${this.discount_code.coupon}`).then(
        function() {
          vm.$store.dispatch("snack", {
            text: 'Affiliate link copied to clipboard'
          });
        },
        function(e) {
          console.log("Can not copy", e);
        }
      );
    }
  },
  watch: {
    coupon() {
      if (this.coupon) {
        this.coupon = this.coupon.toUpperCase()
        this.$apollo
          .query({
            client: "localClient",
            query: Q_CHECK_DISCOUNT_COUPON,
            variables: {
              coupon: this.coupon
            }
          })
          .then(({ data }) => {
            if (data.check_discount_coupon.success) {
              this.couponExists = true;
            } else {
              this.couponExists = false;
            }
          });
      } else {
        this.couponExists = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  .content-body {
    .coupon {
      border-radius: 10px;
      background: linear-gradient(264deg, rgba(27, 25, 60, 0.57) 0%, rgba(27, 25, 60, 0.19) 100%), #9C27B0;
      padding: 54px 60px;
      color: #ffffff;
      display: flex;

      .description {
        width: 45%;
        font-weight: 400;
        line-height: 24px;
        .title {
          font-size: 24px;
          font-weight: 600;
          line-height: 32px;
          margin-bottom: 20px;
        }
        .text {
          font-size: 14px;
          .bold {
            font-weight: 600;
          }
        }
      }

      .separator {
        width: 1px;
        background: #ffffff;
        opacity: 0.2;
        margin-left: 60px;
      }

      .coupon-code {
        flex: 1;
        padding-left: 60px;
        .title {
          font-weight: 600;
          margin-bottom: 20px;
        }
        .create-code, .code-container {
          display: flex;
          background: #ffffff;
          color: #59588D;
          border-radius: 4px;
          padding: 10px 12px;
          margin-bottom: 20px;
          line-height: 24px;
          input, span {
            border: none;
            background: transparent;
            color: #100E2A;
            font-weight: 600;
            &:focus {
              outline: none;
            }
            &::placeholder {
              color: #100E2A;
            }
            &::-webkit-input-placeholder {
              color: #100E2A;
            }
          }
          &.is-invalid {
            border: 2px solid #FF0000;
          }
        }
        .create-code {
          span {
            color: #59588D;
            font-weight: 400;
          }
        }
        .code-container {
          display: flex;
          .code-text {
            color: #59588D;
          }
        }
        .lets-go {
          display: flex;
          justify-content: flex-end;
          button {
            color: #100E2A;
            font-size: 16px;
            font-weight: 600;
            padding: 9px 18px;
            border-radius: 10px;
            background: var(--White, #FFF);

            &:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }
        }
        .your-link {
          display: flex;
          .code-container {
            width: 100%;
            margin-bottom: 0;
            border-radius: 10px;
            input {
              width: 100%;
            }
          }
          .copy {
            margin-left: 20px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 14px;
            height: 44px;;
            cursor: pointer;

            svg {
              // width: 50px;
              path {
                fill: #100E2A;
              }
            }
          }
        }
      }
    }
    .results {
      width: 100%;
      margin-top: 55px;
      padding: 20px 12px;
      background: #24224a;
      box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
      border-radius: 10px;

      .summary {
        width: 100%;
        display: flex;
        margin: 20px 0;
        gap: 16px;

        .card {
          flex: 1;
          padding: 10px 10px;
          height: 60px;
          background: #1B193C;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;

          .total {
            color: #ffffff;
            font-size: 16px;
          }

          .label {
            text-align: center;
            color: #8786ab;
            font-size: 12px;
            margin-top: 3px;
          }
        }
      }

      .title {
        font-size: 18px;
        color: #ffffff;
      }

      table {
        width: 100%;
        border-collapse: collapse;

        thead {
          tr {
            th {
              padding: 18px 18px 10px 10px;
              font-weight: 600;
              font-size: 12px;
              line-height: 15px;
              color: $text-type-0;
            }
          }
        }

        tbody {
          tr {
            background: $bg-type-1;
            border-bottom: solid 5px transparent;

            td {
              padding: 6px;
              font-weight: 600;
              font-size: 14px;
              line-height: 22px;
              color: white;
              mix-blend-mode: normal;
              opacity: 0.9;

              &:first-child {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
              }

              &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
              }
            }
          }
        }
      }
    }
  }
}

@keyframes bounce {
  50% {
    transform: scale(1.2);
  }

  75% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

.dedicated-number {
  flex: 1;
  display: flex;
  background: #9c27b0;
  color: white;
  border-radius: 10px;
  padding: 12px 24px;

  margin-bottom: 48px;

  .text {
    display: flex;
    flex-direction: column;
    padding-right: 30px;

    .title {
      font-weight: 900;
      font-size: 16px;
      line-height: 26px;
      color: #ffffff;

      i {
        margin-right: 5px;
      }
    }

    .details {
      margin-top: 5px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    flex: 1;

    button {
      white-space: nowrap;
    }
  }
}

@media screen and (max-width: 800px) {
  .content {
    padding: 20px;
  }
  .content .content-body .coupon {
    display: flex;
    flex-direction: column;
    padding: 24px 32px;
  }
  .content .content-body .coupon .description {
    width: 100%;
  }
  .content .content-body .coupon .coupon-code {
    padding-left: 0;
  }
}
</style>
